module.exports = __webpack_public_path__ + "media/images/indeed-logo-57074dd4e9b5092b16e39b073f9d4b13.jpg";